export default __webpack_public_path__ + "static/media/eye.79d76b28.svg";